var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossGrayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1725 9.99361C11.498 10.319 11.498 10.8467 11.1725 11.1721C10.8471 11.4975 10.3194 11.4975 9.994 11.1721L5.99995 7.17812L2.00601 11.1721C1.68058 11.4976 1.15294 11.4976 0.8275 11.1721C0.502061 10.8467 0.502056 10.3191 0.82749 9.99362L4.82143 5.99962L0.827331 2.00559C0.501891 1.68015 0.501893 1.15252 0.827332 0.827084C1.15277 0.50165 1.68041 0.501649 2.00585 0.827083L5.99993 4.8211L9.99386 0.827098C10.3193 0.501658 10.8469 0.501655 11.1724 0.827089C11.4978 1.15252 11.4978 1.68016 11.1724 2.0056L7.17845 5.9996L11.1725 9.99361Z",
    fill: "#4B5768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossGrayIcon);
export default __webpack_public_path__ + "static/media/cross-gray-icon.c8562bbadd45656f07e4f96b31d4071b.svg";
export { ForwardRef as ReactComponent };